//Core
import React, {FC} from "react";
//Styles
import {LogoBox, SidebarContainer, SideBarFlexColumn} from "./SideBar.styles";
import {MainContainer} from "@/styles/layout/boxes";
//Images
import LogoSvg from "../../../assets/svg/logo";
//Components
import SideBarButtons from "./content/buttons/SideBarButtons";
import SideBarBottomMenu from "./content/bottom/SideBarBottomMenu";
//Hooks
import {usePathname} from "@/utils/hooks/usePathname";
import {useNavigate} from "react-router-dom";

const SideBar: FC = () => {
    const {isLoginPage} = usePathname();
    const navigate = useNavigate();

    if (isLoginPage) return null;

    return (
        <SidebarContainer open anchor={"left"} variant={"persistent"}>
            <MainContainer sx={{paddingBottom: 0}}>
                <SideBarFlexColumn>
                    <LogoBox onClick={() => navigate('/')}><LogoSvg/></LogoBox>
                    <SideBarButtons/>
                    <SideBarBottomMenu/>
                </SideBarFlexColumn>
            </MainContainer>
        </SidebarContainer>
    );
}

export default SideBar;